<!-- 排污口详情 -->
<template>
  <div class="dialog-blowdown">
    <div class="header">
      <div class="title">{{ data?.pwkName || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item">
            <span class="key">所属镇街:</span>
            <span class="value">{{ data?.szzj || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所属流域:</span>
            <span class="value">{{ data?.szly || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">排污口类型:</span>
            <span class="value">{{ data?.pwklx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">排污口名称:</span>
            <span class="value">{{ data?.pwkmc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">入河方式:</span>
            <span class="value">{{ data?.rhfs || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">整治类型:</span>
            <span class="value">{{ data?.zzlx || '-' }}</span>
          </div>
        </div>
        <div>
          <img style="max-width: 500px" :src="data?.pwkDataPic || ''" alt="" />
        </div>
        <div>
          <img style="max-width: 500px" :src="data?.pwkPic || ''" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-blowdown {
  width: 53.35rem;
  min-width: 53.35rem;
  .header {
    text-align: left;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
